import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";
import { EnumMessageType } from "../../core/Helper";
import { BiInfoSquare } from "react-icons/bi";
import { AiFillInfoCircle } from "react-icons/ai";
import { MyModal } from "../../features/RadConnStyle";

export default function MessageDialog(props) {
  const [param, setParam] = props.param;

  const handleClose = (value) => {
    setParam({ show: false, title: "", message: "", type: EnumMessageType.OK });
  };

  const getTitleStyle = () => {};

  return (
    <MyModal show={param.show} centered>
      <Modal.Header style={{ backgroundColor: "#231b38" }}>
        <AiFillInfoCircle />
        <div style={titleStyle}>{param.title && param.title}</div>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#181717" }}>
        <MsgBox>
          <div style={{ margin: "45px 0 45px 0" }}>
            {param.message && param.message}
          </div>
          <Button variant="primary" onClick={() => handleClose(true)}>
            ตกลง
          </Button>{" "}
        </MsgBox>
      </Modal.Body>
      {/* <Modal.Footer></Modal.Footer> */}
    </MyModal>
  );
}

const MsgBox = styled.p`
  font-size: large;
  color: #f8f2f2;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const titleStyle = {
  color: "#21e221",
  flex: "1",
  justifyContent: "center",
  display: "flex",
};
const messageAreaStyle = {};
